import { Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import {Partner} from '../../shared/api/model/partner';
import {AgentService} from '../../shared/api/resources/agent/agent.service';
import {Product} from '../../shared/api/model/product';
import {Event} from '../../shared/api/model/event';
import {SettingsService} from '../../shared/api/resources/settings/settings.service';
import * as moment from 'moment';
import {Booking} from '../../shared/api/model/booking';
import {GenderPrice} from '../../shared/api/model/gender-price';
import {BookingService} from '../../shared/api/resources/booking/booking.service';
import {BookingCalculation} from '../../shared/api/model/booking-calculation';
import {AgentReservationService} from '../../shared/api/resources/agent-reservation/agent-reservation.service';
import {Billing} from '../../shared/api/model/billing';
import {PaymentParcel} from '../../shared/api/model/payment-parcel';
import {UserService} from '../../shared/api/resources/user/user.service';
import {ToasterService} from '../../shared/global/toaster.service';
import {Customer} from '../../shared/api/model/customer';
import {Transport} from '../../shared/api/model/transport';
import {LoadingService} from '../../shared/global/loading.service';
import {BookingCalculatedParcel} from '../../shared/api/model/booking-calculated-parcel';
import {Subscription} from 'rxjs/Subscription';
import {StaticUtils} from '../../shared/utils/static-utils';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MandatoryExtrasWarningComponent} from '../../shared/atoms/mandatory-extras-warning/mandatory-extras-warning.component';
import {Promocode} from '../../shared/api/model/promocode';
import {SupplierService} from '../../shared/api/resources/supplier/supplier.service';
import {ToastsManager} from 'ng2-toastr';

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  preserveWhitespaces: false,
  styleUrls: ['./booking.component.scss']
})
export class BookingComponent implements OnInit {
  private _sub: any;
  private _promocode = '';

  utils = StaticUtils;
  booking = new Booking();
  transportActive = false;
  detailsActive = true;
  extrasActive = false;
  partnerId: number;
  eventId: number;
  partner: Partner;
  product: Product;
  event: Event;
  genderPrices: GenderPrice[];
  calculatedPrice: BookingCalculation;
  moment = moment;
  calculatedPriceSub: Subscription;
  calculatingPrice = false;
  creatingReservation = false;
  gettingEventInfo = true;
  validCustomer = false;
  isPromocodesCollapsed = true;
  collapseStyles = {'overflow': 'hidden'};
  findingPromocode = false;
  promocodeNotValid = false;
  bookingAnswer;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _agentService: AgentService,
    private _settingsService: SettingsService,
    private _bookingService: BookingService,
    private _agentReservationService: AgentReservationService,
    private _supplierService: SupplierService,
    private _userService: UserService,
    private _loadingService: LoadingService,
    private _toasterService: ToasterService,
    private _modalService: NgbModal,
    private _toastr: ToastsManager) { }

  public ngOnInit(): void {
    this.booking.creatorUserAccount = this._userService.userAccount;
    this.booking.creatorAgent = this._userService.userAccount.userAccountTypeDefault.agent;

    this.booking.customer = new Customer();
    this.booking.transport = new Transport();

    const billing = new Billing();
    billing.payments = [new PaymentParcel()];
    this.booking.billing = billing;
    this.booking.payments = [new PaymentParcel()];

    this.booking.note = '';

    this._sub = this._route.params.subscribe(params => {
      this.partnerId = parseInt(params['id'], 10);
      this.eventId = parseInt(params['eventId'], 10);
      this._agentService.getEvent(this.partnerId, this.eventId).subscribe(
        (event: Event) => {
          this.event = event;
          this.product = event.product;
          this.booking.event = this.event;
          this.booking.bookingGenderPrices = event.eventGenderPrices;
          this._initGenderPrices();
          this.checkMandatoryExtras(this.product.extras);
          this.disableGettingEventInfo();
        }
      );
    });
  }

  private _initGenderPrices(): void {
    this.genderPrices = this.event.eventGenderPrices;
    if (this.genderPrices.length > 0 && this.genderPrices.some(genderPrice => genderPrice.genderPriceType === 1)) {
      // it should only be one fake, but you never know...
      const fakeGenderPricesIndexes = this.genderPrices
        .map((genderPrice, index) => genderPrice.genderPriceType === 1 && genderPrice.isExcludedFromBilling === false ? index : null);
      for (const index of fakeGenderPricesIndexes) {
        if (index !== null) {
          this.genderPrices[index].quantityToBook = 1;
        }
      }
      if (fakeGenderPricesIndexes.some(index => index !== null)) {
        this.updateBookGenderPrices({
          genderPrices: this.genderPrices,
        });
      }
    } else if (this.genderPrices.some(genderPrice => genderPrice.genderPriceType === 3) && this.event.passengerSettings.format !== 1) {
      this.updateBookGenderPrices({
        genderPrices: this.genderPrices,
      });
    }
  }

  updateCalculatedPrice() {
    if (this.calculatedPriceSub) {
      this.calculatedPriceSub.unsubscribe();
    }
    this.calculatedPriceSub = this._bookingService.getCalculatedPrice(this.booking, this.partnerId).subscribe(
      (calculatedPrice: BookingCalculation) => {
        this.calculatedPrice = calculatedPrice;
        this.genderPrices = calculatedPrice.bookingGenderPrices;
        this.booking.calculationsGUID = this.calculatedPrice.calculationsGUID;
        this.booking.billing.payments[0].value = calculatedPrice.grandTotalDepositValueRequired;
        this.booking.payments[0].value = calculatedPrice.grandTotal;
        this.booking.payments[0].allocations = [{
          amount: calculatedPrice.grandTotalDepositValueRequired,
          change: 0,
          type: -100,
          isAgentPayment: true
        }];
        this.booking.payments[0].TreasurerAgent = this._userService.userAccountTypeDefault.agent;
      },
      undefined,
      () => {
        this.disableCalculatingPrice();
      }
    );
  }

  checkMandatoryExtras(extras: any[]) {
    const mandatoryExtras: any[] = [];
    for (const extra of extras) {
      if (extra.isMandatory) {
        mandatoryExtras.push(extra);
      }
    }
    if (mandatoryExtras.length > 0) {
      const modalRef = this._modalService.open(MandatoryExtrasWarningComponent, {size: 'sm'});
      modalRef.componentInstance.extras = mandatoryExtras;
    }
  }

  updateBookGenderPrices(data: any) {
    this.calculatingPrice = true;
    this.booking.bookingGenderPrices = data.genderPrices;
    this.booking.event.eventGenderPrices = data.genderPrices;
    
    this.updateExtraTransports();
    this.updateCalculatedPrice();
  }
  
  updateExtraTransports() {
    let showWarning = false;
    const hasBookingComponents = this.booking.bookingComponents === undefined ? false : true;
    const totalPax = this.booking.bookingGenderPrices.reduce((acc, genderPrice) => {
      return acc += genderPrice.quantityToBook
    }, 0)

    if (hasBookingComponents) {
      this.booking.bookingComponents.map((comp) => {
        if (comp.component.componentType === 1 && comp.quantity > 0) {
          if (comp.quantityAvailable >= totalPax || comp.quantityAvailable <= 0) {
            comp.quantity = totalPax;
          } else {
            showWarning = true;
            comp.quantity = 0;
          }
        }
      })
  
      if (showWarning) {
        this.booking.transport.transfers = [];
        this.showError('Please edit transports again!')
      }
    }
  }

  showError(msg: string) {
    this._toastr.error(msg, 'Transport - No more seat available');
  }

  updateTransfers(data: any) {
    this.booking.transport = data;
    this.updateCalculatedPrice();
  }

  updateTransports(data: any) {
    this.booking.bookingComponents = data;
    this.updateCalculatedPrice();
  }

  updateExtras(data: any) {
    this.calculatingPrice = true;
    this.booking.bookingComponents = data;
    this.updateCalculatedPrice();
  }

  get hasExtras(): boolean {
    return this.booking.bookingComponents.some(a => a.quantity > 0);
  }

  disableCalculatingPrice() {
    this.calculatingPrice = false;
  }

  disableCreatingReservation() {
    this._loadingService.showLoading = false;
    this.creatingReservation = false;
  }

  disableGettingEventInfo() {
    this.gettingEventInfo = false;
  }

  updateBookCustomer(data: any) {
    this.booking.customer = data.customer;
    this.booking.note = data.notes;
  }

  updateBookAnswer(data: any) {
    this.booking.bookingAnswer = data.bookingAnswer;
    this.booking.bookingQuestion = this.event.bookingQuestion;
  }

  createReservation(print = false) {
    this.creatingReservation = true;
    this._loadingService.showLoading = true;
    this._agentReservationService.createReservation(this.booking).subscribe(
      (booking: Booking) => {
        this.booking = booking;
        if (print) {
          this._agentService.downloadTicket(booking.id, this.partnerId).subscribe(
            (data) => {
              function base64ToArrayBuffer(base64) {
                const binaryString = window.atob(base64);
                const binaryLen = binaryString.length;
                const bytes = new Uint8Array(binaryLen);
                for (let i = 0; i < binaryLen; i++) {
                  const ascii = binaryString.charCodeAt(i);
                  bytes[i] = ascii;
                }
                return bytes;
              }
              function openByteArrayInNewTab(byte) {
                const blob = new Blob([byte], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(blob);
                window.open(fileURL, '_blank');
              }

              const dataArr = base64ToArrayBuffer(data);
              openByteArrayInNewTab(dataArr);
            },
            undefined,
            () => {
              this.finishBooking();
            }
          );
        } else {
          this.finishBooking();
        }
      },
      undefined,
      () => {
        if (!print) {
          this.disableCreatingReservation();
        }
      }
    );
  }

  finishBooking() {
    this._toasterService.showInfo('Booking created successfully: #' + this.booking.id);
    if (this.product.hasManualConfirmation) {
      this._toasterService.showWarning('This booking requires supplier confirmation.');
    }
    this.disableCreatingReservation();
    this._router.navigate(['../../../../bookings'], { relativeTo: this._route });
  }

  goToTransport() {
    this.transportActive = true;
    this.detailsActive = false;
    this.extrasActive = false;
  }

  goToDetails() {
    this.transportActive = false;
    this.detailsActive = true;
    this.extrasActive = false;
  }

  goToExtras() {
    this.transportActive = false;
    this.detailsActive = false;
    this.extrasActive = true;
  }

  cancel() {
    this._router.navigate(['../../calendar'], { relativeTo: this._route });
  }

  isPaxSelected() {
    let result = false;

    if (this.booking && this.booking.bookingGenderPrices) {
      for (const genderPrice of this.booking.bookingGenderPrices) {
        if (genderPrice.quantityToBook > 0) {
          result = true;
          break;
        }
      }
    }
    return result;
  }

  togglePromocodesCollapse() {
    this.isPromocodesCollapsed = !this.isPromocodesCollapsed;
    this.promocodeNotValid = false;
    if (this.isPromocodesCollapsed) {
      this.collapseStyles = {'overflow': 'hidden'};
    } else {
      setTimeout(() => {
        this.collapseStyles = {'overflow': 'initial'};
      }, 500);
    }
  }

  async applyPromocode() {
    try {
      this.findingPromocode = true;
      const promocode = await this.findPromocode();
      this.findingPromocode = false;

      if (this.isPromocodeValid(promocode)) {
        this.booking.attachPromocode = this._promocode;
        this.updateCalculatedPrice();
      } else {
        this.promocodeNotValid = true;
      }

    } catch (e) {
      this.findingPromocode = false;
    }
  }

  findPromocode(): Promise<Promocode> {
    return new Promise((resolve, reject) => {
      let result: Promocode;
      this._supplierService.findPromocode(this.booking.event.supplierId, this._promocode).subscribe(
        (promocode: Promocode) => result = promocode,
        undefined,
        () => {
          if (result !== undefined) {
            resolve(result);
          } else {
            reject();
          }
        });
    });
  }

  isPromocodeValid(promocode: Promocode): boolean {
    let result = false;
    if (promocode) {
      const isAfterStart = moment().isAfter(moment(promocode.validPeriodStart));
      const isBeforeEnd = moment().isBefore(moment(promocode.validPeriodFinish));
      result = isAfterStart && isBeforeEnd && promocode.status === 1 && promocode.promocodeType === 1;
    }

    return result;
  }

  get seatsNumber(): number {
    let result = 0;
    if (this.booking && this.booking.bookingGenderPrices) {
      for (const genderPrice of this.booking.bookingGenderPrices) {
        result += genderPrice.quantityToBook;
      }
    }
    return result;
  }

  get extrasParcels(): BookingCalculatedParcel[] {
    return this.calculatedPrice.parcels.filter((parcel) => parcel.itemType && parcel.itemType === 2);
  }

  get showComissions(): boolean {
    return this._userService.userHasAccess('booking-comissions');
  }

  get depositValue(): string {
    let result = '0,00 €';

    if (this.calculatedPrice) {
      if (this.calculatedPrice.depositPaymentType === 1) { // Require payment of full amount
        result = 'Full amount';
      } else if (this.calculatedPrice.depositPaymentType === 2) { // Require payment of deposit
        if (this.calculatedPrice.depositType === 0) { // Fixed amount (total)
          result = this.utils.convertValueToCurrency(this.calculatedPrice.depositValue);
        } else if (this.calculatedPrice.depositType === 1) { // Percentage
          result = this.utils.convertValueToCurrency(this.calculatedPrice.totalGrossprice * (this.calculatedPrice.depositValue / 100))
            + ' (' + this.calculatedPrice.depositValue + '%)';
        } else if (this.calculatedPrice.depositType === 2) { // Same as commission
          result = this.comissionValue;
        }
      }
    }

    return result;
  }

  get comissionValue(): string {
    let result = '0,00 €';

    if (this.calculatedPrice) {
      result = this.utils.convertValueToCurrency(this.calculatedPrice.grandTotalCommission);
    }

    return result;
  }

  get promocode(): string {
    return this._promocode;
  }

  set promocode(value: string) {
    this._promocode = value;
    this.promocodeNotValid = false;
  }

  get isPerGroupPriceGroup(): boolean {
    if (!this.event.passengerSettings || !this.event.passengerSettings.configurations || !this.genderPrices) return false;

    return (this.event.passengerSettings.format === 0 && this.genderPrices.some(price => price.genderPriceType === 3));
  }

  get isPerOrderPrice(): boolean {
    if (!this.genderPrices) return false;

    return this.genderPrices.some(price => price.genderPriceType === 1);
  } 
}



// WEBPACK FOOTER //
// ./src/app/experiences/booking/booking.component.ts